import React, { ReactNode } from 'react';
import { Link as DomLink } from 'react-router-dom';
import { LinkContainer } from './Link.styles';

export type Target = '_blank' | '_self' | '_parent' | '_top';

export interface LinkProps {
  title: ReactNode;
  dataQaId?: string;
  path?: string;
  href?: string;
  router?: boolean;
  size?: string;
  selected?: boolean;
  disabled?: boolean;
  disableVisited?: boolean;
  rel?: string;
  style?: {};
  onClick?: (e: React.MouseEvent) => void;
  target?: Target;
}

const onMouseDown = (event: React.MouseEvent<HTMLAnchorElement>) => event.preventDefault();

const Link: React.FC<LinkProps> = ({
  title,
  path = '/',
  dataQaId,
  href,
  router,
  size,
  selected,
  disabled,
  disableVisited,
  rel,
  style,
  onClick,
  target = '_self',
}: LinkProps) => (
  <LinkContainer selected={selected} disabled={disabled} disableVisited={disableVisited} size={size}>
    {router ? (
      <DomLink to={path} data-qa-id={dataQaId} onMouseDown={onMouseDown}>
        {title}
      </DomLink>
    ) : (
      <a
        href={href}
        onClick={onClick}
        data-qa-id={dataQaId}
        onMouseDown={onMouseDown}
        target={target}
        rel={rel}
        style={style}
      >
        {title}
      </a>
    )}
  </LinkContainer>
);

export default Link;
